import React from "react";

const RecentItems = ({ showRecentItems, setShowRecentItems }) => {

  return (
    <>
      <span
        onClick={setShowRecentItems}
        style={{
          color: showRecentItems ? "rgb(255, 255, 255)" : "rgb(13, 110, 253)",
          fontSize: "12px",
          marginTop: "7.5px",
          border: "1px solid rgb(13, 110, 253)",
          backgroundColor: showRecentItems
            ? "rgb(13, 110, 253)"
            : "rgb(255, 255, 255)",
          marginBottom: "0",
          padding: "3px 5px",
          cursor: "pointer",
          borderRadius: "4px",
        }}
      >
        Recent Items
      </span>
      &nbsp;&nbsp;
    </>
  );
};

export default RecentItems;
